(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.related = related;
var _utilities = require("./utilities.js");
function related() {
  var container = document.getElementById('related-posts');
  var containerPeople = document.getElementById('related-posts-people');
  var postId = '';
  if (container) {
    postId = container.dataset.postId;
  } else if (containerPeople) {
    postId = containerPeople.dataset.postId;
  }
  if (container || containerPeople) {
    var url = '';
    if (container) {
      url = '/wp-json/ki/v1/related/' + postId;
    } else {
      url = '/wp-json/ki/v1/expert/' + postId;
      container = containerPeople;
    }
    console.log('URL:' + url);
    fetch(url).then(function (res) {
      return res.json();
    }).then(function (posts) {
      if (!posts.length) {
        //container.innerHTML = 'No related posts';
        console.log('container: ', container);
        var more = document.getElementById('single-related');
        (0, _utilities.slideUp)(more, 200);
        return;
      }
      posts.forEach(function (post) {
        var article = document.createElement('article');
        article.className = "col-4 ki-card";
        var link = document.createElement('a');
        link.className = 'card-link';
        link.href = post.link;
        link.setAttribute('aria-label', "Read the story: " + post.title);
        article.appendChild(link);
        var cardImage = document.createElement('div');
        cardImage.className = 'card-image';
        link.appendChild(cardImage);

        // image
        if (post.img) {
          var img = document.createElement('img');
          img.src = post.img.src;
          if (post.img.srcset) {
            img.srcset = post.img.srcset;
          }
          if (post.img.sizes) {
            img.sizes = post.img.sizes;
          }
          img.alt = post.img.alt;
          img.loading = 'lazy';
          img.decoding = 'async';
          cardImage.appendChild(img);
        }
        var content = document.createElement('div');
        content.className = 'card-content';
        var h2 = document.createElement('h2');
        h2.textContent = post.title;
        content.appendChild(h2);
        if (post.releaseDate) {
          var date = document.createElement('div');
          date.className = 'release-date post-meta';
          var d = new Date(post.releaseDate * 1000);
          date.textContent = d.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
          content.appendChild(date);
        }
        cardImage.appendChild(content);
        container.appendChild(article);
      });
    }).catch(function (err) {
      container.innerHTML = 'Error loading posts';
      console.error(err);
    });
  }
}

},{"./utilities.js":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.single = single;
var _utilities = require("./utilities.js");
function single() {
  var titleBar = document.getElementById('chapters-bar');
  var chaptersBtn = document.getElementById('chapters-btn');
  var chaptersPanel = document.getElementById('toc-panel');
  window.addEventListener("scroll", function () {
    if (window.scrollY > 400) {
      titleBar?.classList.add("scrolled");
    } else if (window.scrollY <= 400) {
      titleBar?.classList.remove("scrolled");
      if (chaptersPanel) {
        chaptersPanel.style.display = 'none';
      }
    }
  });
  chaptersBtn?.addEventListener("click", function () {
    if (chaptersPanel.style.display === 'block') {
      (0, _utilities.slideUp)(chaptersPanel);
    } else {
      (0, _utilities.slideDown)(chaptersPanel);
    }
  });

  // Close chapters after click on mobile only
  var mq = window.matchMedia("(max-width: 781px)");
  function handleChange(e) {
    var tocLinks = document.querySelectorAll('.toc-label a');
    tocLinks.forEach(function (link) {
      // link.addEventListener('click', (e) => {
      //     slideUp(chaptersPanel, 200);
      // })
    });
  }
  // Initial check
  handleChange(mq);
  // Listen for changes
  mq.addEventListener("change", handleChange);

  // All h2 headings with IDs
  var headings = Array.from(document.querySelectorAll('h2[id]'));
  // All TOC items
  var tocItems = document.querySelectorAll('#toc li');

  // Map headings to their TOC <li>
  var headingToTOC = {};
  headings.forEach(function (h) {
    var link = document.querySelector("#toc a[href=\"#" + h.id + "\"]");
    if (link) headingToTOC[h.id] = link.closest('li');
  });

  // Listen for scroll events (simpler for this behavior than IntersectionObserver)
  window.addEventListener('scroll', function () {
    var scrollPosition = window.scrollY + 130; // adjust for sticky header height
    var activeSet = false;
    for (var i = headings.length - 1; i >= 0; i--) {
      var heading = headings[i];
      var offsetTop = heading.offsetTop;
      if (scrollPosition >= offsetTop) {
        // Remove active from all TOC items first
        tocItems.forEach(function (li) {
          return li.classList.remove('active');
        });

        // Add active to current TOC item
        headingToTOC[heading.id]?.classList.add('active');
        activeSet = true;
        break; // stop after first match from bottom
      }
    }

    // Optional: remove active from first heading if scrolled above it
    if (!activeSet) {
      tocItems.forEach(function (li) {
        return li.classList.remove('active');
      });
    }
  });
  var tocList = document.querySelectorAll('#end-note p');
  tocList.forEach(function (p) {
    var sup = p.querySelector('sup');
    if (!sup) return;
    var number = sup.textContent.trim();
    var note = p.querySelector('.up-arrow');
    if (!note) {
      p.innerHTML += " <a href=\"#footnote-" + number + "\" class=\"up-arrow\" endnote=\"" + number + "\">\u2191</a>";
    } else {
      note.innerHTML = "\u2191";
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('up-arrow')) return;
    e.preventDefault();
    var number = e.target.getAttribute('endnote');
    var target = document.querySelector(".end-note[endnote=\"" + number + "\"]");
    var offset = 110;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  });
  var tocLinks = document.querySelectorAll('.is-style-ki-has-footnote sup');
  tocLinks.forEach(function (sup, index) {
    var number = sup.textContent.trim();
    sup.innerHTML = "<a href=\"#endnote-" + number + "\" class=\"end-note\" endnote=\"" + number + "\">" + number + "</a>";
  });
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('end-note')) return;
    e.preventDefault();
    var number = e.target.getAttribute('endnote');
    var target = document.querySelector('#end-note');
    var offset = 110;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  });
}

},{"./utilities.js":3}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideDown = slideDown;
exports.slideUp = slideUp;
function slideDown(element) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var animateOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  element.style.display = "block";
  element.style.overflow = "hidden";
  element.style.height = "0px";
  var originalDisplay = getComputedStyle(element).display === 'none' ? 'block' : getComputedStyle(element).display;
  if (animateOpacity) {
    element.style.opacity = "0"; // Start fully transparent
  }
  var endHeight = element.scrollHeight;
  requestAnimationFrame(function () {
    var startTime = performance.now();
    var onComplete = function onComplete(element) {
      element.style.overflow = "";
      element.style.overflowY = "auto";
      element.style.overflowX = "hidden";
      element.classList.add('slide-open');
    };
    function animate(currentTime) {
      element.style.overflowY = "hidden";
      var elapsedTime = currentTime - startTime;
      var progress = Math.min(elapsedTime / duration, 1);
      element.style.height = progress * endHeight + "px";
      if (animateOpacity) {
        element.style.opacity = progress; // Increase opacity if enabled
      }
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        element.style.height = ""; // reset height
        element.style.display = originalDisplay;
        if (animateOpacity) {
          element.style.opacity = "";
        }
        if (typeof onComplete === "function") {
          onComplete(element);
        }
      }
    }
    requestAnimationFrame(animate);
  });
}
function slideUp(element) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var animateOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  element.style.overflow = "hidden";
  var startHeight = element.scrollHeight;
  if (animateOpacity) {
    element.style.opacity = "1"; // Ensure it's fully visible
  }
  requestAnimationFrame(function () {
    var startTime = performance.now();
    function animate(currentTime) {
      var elapsedTime = currentTime - startTime;
      var progress = Math.min(elapsedTime / duration, 1);
      element.style.height = (1 - progress) * startHeight + "px";
      if (animateOpacity) {
        element.style.opacity = 1 - progress; // Decrease opacity if enabled
      }
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        element.style.display = "none";
        element.classList.remove('slide-open');
        element.style.height = "";
        if (animateOpacity) {
          element.style.opacity = "";
        }
      }
    }
    requestAnimationFrame(animate);
  });
}

},{}],4:[function(require,module,exports){
"use strict";

var _single = require("./parts/single.js");
var _related = require("./parts/related.js");
window.addEventListener("load", function (event) {
  console.log('single');
  (0, _single.single)();
  (0, _related.related)();
});

},{"./parts/related.js":1,"./parts/single.js":2}]},{},[4]);
